import { type IntegrationData } from 'src/shared/api/integrations/factorial';
import { sanitizeCustomFields } from '../utils/sanitizeCustomFields';

type A3BaseConfig = {
  subsidiary: string;
  companyCode: string;
  includeSalaryTypes: SalaryTypes[];
  recordTransactions: boolean;
};

export type A3Values = A3BaseConfig & {
  customFields: Record<string, string | null | undefined> | null | undefined;
  withCustomFields: boolean;
};

export type A3Config = A3BaseConfig & {
  customFields: Record<string, string> | undefined;
};

export type SalaryTypes = {
  conceptCode: number;
  description: string;
  conceptType: string;
};

type GetCompanyArgs = {
  integrationData?: IntegrationData[];
  companyName: string;
};

export const a3InitialValues: A3Values = {
  subsidiary: '',
  companyCode: '',
  includeSalaryTypes: [],
  recordTransactions: false,
  customFields: null,
  withCustomFields: false
};

export const mapSalaryTypes = (data: SalaryTypes[] | undefined) => {
  if (!data) return [];

  const mappedData = data.map(e => ({ label: e.description, value: e.description.trim().toUpperCase() }));

  return mappedData;
};

export const mapFormDataToA3Config = (formData: A3Values): A3Config => ({
  ...formData,
  customFields: formData.withCustomFields ? sanitizeCustomFields(formData.customFields) : undefined
});

export const getCompany = ({ integrationData, companyName }: GetCompanyArgs) => {
  if (!integrationData) return;
  const company = integrationData.find(company => company.subsidiary === companyName);

  return company;
};
